import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { cerrarSession, isAuthenticaded } from '../../Services/AuthService';

class LoginComposicion extends Component {
    /* ---------------------------------------------------------------------- */
    componentDidMount() {
        if( isAuthenticaded() ) {
            this.props.history.push("/usuario");
        } else {
            cerrarSession();
        }
    }
    /* ---------------------------------------------------------------------- */
    render() {
        return ( <React.Fragment> {this.props.children} </React.Fragment> );
    }
}

export default withRouter( LoginComposicion );